import React from "react";
import { Container, Typography } from "@mui/material";

const HowToUse = () => {
  return (
    <Container sx={{ textAlign: "center", mt: 4 }}>
      <Typography variant="h4">How to Use?</Typography>
    
      <iframe
        width="100%"
        height="315"
        src="https://www.youtube.com/embed/utgwXCoEMko"
        title="YouTube video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ marginTop: "20px", borderRadius: "10px" }}
      ></iframe>
    </Container>
  );
};

export default HowToUse;
